import { css } from 'styled-components';

export const focusOutline = css`
  outline: 0.125rem solid var(--color-secondary-500);
  outline-offset: 0.125rem;
`;
